"use strict";

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var hs_web_style_guide_1 = require("@headspace/hs-web-style-guide");

var colors_1 = require("@headspace/hs-web-style-guide/dist/colors");

var dividerStyles = hs_web_style_guide_1.css({
  color: colors_1.carrarra,
  margin: 0,
  padding: 0,
  borderTop: "1px solid " + colors_1.carrarra,
  borderBottom: 'none'
});

function Divider() {
  return React.createElement("hr", __assign({}, dividerStyles));
}

exports.Divider = Divider;